import React, {FC} from 'react';
import {Flex} from '@priority-software/priority-style-react';
import {useRichText} from './hooks/useRichText';
import {Editor} from './parts/Editor/Editor';
import cx from 'classnames';
import styles from './styles.module.scss';
import {ETargetAutoFill} from './types';

interface IRichTextProps {
    targetAutoFill: React.MutableRefObject<ETargetAutoFill>;
    messageCursorLastPosition: React.MutableRefObject<number>;
    subjectInputRef: React.MutableRefObject<HTMLInputElement>;
}

export const RichText: FC<IRichTextProps> = ({
    targetAutoFill,
    messageCursorLastPosition,
    subjectInputRef
}) => {
    const {renderSubject} = useRichText({
        targetAutoFill,
        messageCursorLastPosition,
        subjectInputRef
    });

    return (
        <Flex componentClasses={cx(styles.richTextEditorContainer, styles.gap)} direction="column">
            {renderSubject()}
            <Editor {...{targetAutoFill}} />
        </Flex>
    );
};
